import { IonContent, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useGetTeamQuery } from '../../api/graphql/generated';
import { BookmarkType } from '../../api/hooks/bookmark.hooks';
import { NestedPageHeader } from '../../components/header/page.header';
import { TeamUsers } from '../../components/team/team-users';
import { useBeaconRouter } from '../../route/route.hooks';

interface TeamUsersPageProps {
  id: string;
}

const TeamUsersPage = (props: TeamUsersPageProps): ReactElement => {
  const { id } = props;

  const { builder } = useBeaconRouter();

  const { data: teamData } = useGetTeamQuery({ variables: { input: { id } } });
  const title = teamData?.getTeam.name;

  return (
    <IonPage>
      <NestedPageHeader
        defaultBackRoute={builder.getTeamMoreRoute(id)}
        title={title}
        bookmarkProps={{ enable: true, type: BookmarkType.TEAM }}
      />
      <IonContent>
        <TeamUsers teamId={id} />
      </IonContent>
    </IonPage>
  );
};

export { TeamUsersPage };
